import { http, HttpResponse } from 'msw';
import { articlesMocks } from '../mocks';

export const articlesHAndler = http.get('*/articles', () =>
  HttpResponse.json(articlesMocks.articles)
);
